type StatisticItem = { label: string; value: number };

type GeneralStatisticsProps = {
  items: StatisticItem[];
};

export default function GeneralStatistics({ items }: {items: any}){
  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
      {items.map((item: any) => (
        <div key={item.label} className="p-4 bg-white shadow rounded">
          <h4 className="text-sm font-semibold text-gray-600">{item.label}</h4>
          <p className="text-xl font-bold text-gray-900">{item.value}</p>
        </div>
      ))}
    </div>
  );
};
